import {Component, Input, ViewChild} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';
import {Response} from '@angular/http';
import {cloneDeep} from 'lodash';
import {DaterangepickerConfig} from 'ng2-daterangepicker';
import {isNullOrUndefined} from 'util';
import {AttachmentType} from '../../../../../../../clients/app/modules/+registration/api';
import {TranslateManager} from '../../../../../../../common/translate';
import {FileUtils, FormDefinitionControl, FormUtils, SetOfControlDefinition} from '../../../../../../../common/utils';
import {AttachmentItem, BusinessCustomerInformation} from '../../api/entity';
import {CorporateAccountsService, FileDownloadService} from '../../api/service';
import {FileUploadModalComponent} from '../file.upload.modal/file.upload.modal.component';
import {
    DATE_FORMAT,
    NewCorporateDetailsComponent
} from '../../../+applications/new/detail/+details/corporate/new.corporate.details.component';
import {
    BackofficeBusinessTypeCategoriesService
} from "../../../../../shared/api/service/backoffice-business-type-categories.service";
import {BusinessTypeCategory} from "../../../../../../../common/api/dictionaries";
import {Observable} from "rxjs/Observable";
import {InjectOptionDialog, OptionDialog} from "../../../../../shared/option-dialog";
import {NotificationManager} from "../../../../../../../common/providers/notification";
import moment = require('moment');


@Component({
    selector: 'tfl-profile-detail-business-customer-information',
    template: require('./business.customer.information.template.html')
})
export class BusinessCustomersInformationComponent {

    @Input('profileId') profileId: number;
    @Input('loading') loading = true;
    @ViewChild(FileUploadModalComponent) fileUploadModalComponent: FileUploadModalComponent;

    @InjectOptionDialog('dialog') dialog: OptionDialog;

    form: FormGroup;
    private readonly MIN_LIST_SIZE = 'minListSize';
    readonly TRADING_NAME_PATTERN = '^[a-zA-Z0-9][a-zA-Z0-9\'.-\\s]*$';
    readonly TAX_IDENTIFICATION_NUMBER_PATTERN = '^[0-9a-zA-Z][0-9a-zA-Z-.]*$';

    readonly CONTROL = {
        ENTITY_NAME: 'entity_name',
        REGISTRATION_DATE: 'registration_date',
        REGISTRATION_NUMBER: 'registration_number',
        TRADING_NAME: 'trading_name',
        TAX_IDENTIFICATION_NUMBER: 'tax_identification_number',
        USER_EMAIL: 'user_email',
        COMPANY_SIGNATORY_PHONE: 'company_signatory_phone',
        BUSINESS_CATEGORY_FILTER: 'business_category_filter',
        BUSINESS_CATEGORIES: 'business_categories',
        BUSINESS_CATEGORIES_RESULT_LIST: 'business_categories_result_list'
    }
    businessCustomerInformation: BusinessCustomerInformation = null;
    originalBusinessCustomerInformation: BusinessCustomerInformation = null;
    isEdited = false;
    attachmentType: AttachmentType = AttachmentType.DOCUMENT;
    loadingState: boolean = false;
    businessCustomerLegalDocumentsId: string = 'business-customer-legal-documents';
    sourceData: any;

    private definition: FormDefinitionControl;

    constructor(private _translationService: TranslateManager,
                private daterangepickerOptions: DaterangepickerConfig,
                private _fileDownloadService: FileDownloadService,
                private _corporateAccountsService: CorporateAccountsService,
                private _fb: FormBuilder,
                private _businessTypeCategoriesService: BackofficeBusinessTypeCategoriesService,
                private _notificationManager: NotificationManager) {

        this.daterangepickerOptions.settings = {
            opens: 'left',
            drops: 'left',
            singleDatePicker: true,
            showDropdowns: true,
            locale: {
                format: DATE_FORMAT,
                firstDay: 1,
                cancelLabel: this._translationService.getValue('COMMON.CLEAR')
            },
            dateLimit: {
                months: 12
            },
            minYear: 1901,
            maxYear: parseInt(moment().format('YYYY'), 10),
            maxDate: moment()
        };
        this.form = this._fb.group({});
    }

    private registerForm(): any {
        let definitions: SetOfControlDefinition = {
            [this.CONTROL.ENTITY_NAME]: {
                value: this.businessCustomerInformation.entityName,
                validation: {maxlength: 50, required: true}
            },

            [this.CONTROL.REGISTRATION_DATE]: {
                value: this.businessCustomerInformation.registrationDate,
            },

            [this.CONTROL.REGISTRATION_NUMBER]: {
                value: this.businessCustomerInformation.registrationNumber,
                validation: {maxlength: 50, required: true}
            },
            [this.CONTROL.TRADING_NAME]: {
                value: this.businessCustomerInformation.tradingName,
                validation: {minlength: 3, maxlength: 100}
            },
            [this.CONTROL.TAX_IDENTIFICATION_NUMBER]: {
                value: this.businessCustomerInformation.taxIdentificationNumber,
                validation: {minlength: 16}
            },
            [this.CONTROL.USER_EMAIL]: {
                value: this.businessCustomerInformation.userEmail,
                validation: {}
            },
            [this.CONTROL.COMPANY_SIGNATORY_PHONE]: {
                value: this.businessCustomerInformation.companySignatoryPhone,
                validation: {}
            },
            [this.CONTROL.BUSINESS_CATEGORY_FILTER]: {},
            [this.CONTROL.BUSINESS_CATEGORIES]: {
                value: this.getBusinessTypeCategories()
            },
            [this.CONTROL.BUSINESS_CATEGORIES_RESULT_LIST]: {}
        };


        this.definition = FormUtils.register(this.form, definitions, this.validBusinessCategories);
    }

    private validBusinessCategories: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
        let filterControl = control.get(this.CONTROL.BUSINESS_CATEGORY_FILTER);
        if (filterControl.value != null) {
            let resultListControl = control.get(this.CONTROL.BUSINESS_CATEGORIES_RESULT_LIST);
            if (!isNullOrUndefined(resultListControl.value)) {
                if ((resultListControl.value && (resultListControl.value.length == 0) && filterControl.value.length >= 3)) {
                    let noMatchesFound = {'matchesNotFound': {value: filterControl.value}};
                    return this.setErrorsToControlAndReturnError(filterControl, noMatchesFound);
                }
            }
        } else {
            let categoryListControl = control.get(this.CONTROL.BUSINESS_CATEGORIES);
            let list = categoryListControl.value;
            if ((isNullOrUndefined(list) || list.length < 1)) {
                let minSizeError = {'minListSize': {value: categoryListControl.value}};
                return this.setErrorsToControlAndReturnError(filterControl, minSizeError);
            }
        }
        return this.setErrorsToControlAndReturnError(filterControl, null);
    };


    private setErrorsToControlAndReturnError(control: AbstractControl, error: ValidationErrors): ValidationErrors {
        control.setErrors(error);
        return error;
    }

    @Input('businessCustomerInformation')
    set setBusinessCustomerInformation(businessCustomerInformation: BusinessCustomerInformation) {
        if (!isNullOrUndefined(businessCustomerInformation)) {
            this.businessCustomerInformation = businessCustomerInformation;
            this.originalBusinessCustomerInformation = cloneDeep(businessCustomerInformation);
            this.daterangepickerOptions.settings.startDate = businessCustomerInformation.registrationDate;
            this._businessTypeCategoriesService.getBusinessTypeCategories().subscribe(response => {
                    this.sourceData = response['records'];
                    this.registerForm();
                    this.setBusinessTypeCategories(this.businessCustomerInformation.businessCategories
                        .map(categoryId => this.sourceData.find(category => category.id == categoryId)));
                }
            );
        }
    }

    onChangeInputValue(event, fieldName) {
        this.businessCustomerInformation[fieldName] = event.target.value;
    }

    saveFiles(files: AttachmentItem[]): void {
        this.form.markAsTouched();
        this.businessCustomerInformation.legalDocuments = this.businessCustomerInformation.legalDocuments.concat(files);
    }

    isAttachmentsValid(): boolean {
        return this.businessCustomerInformation
            && this.businessCustomerInformation.legalDocuments.length != 0;
    }

    uploadFiles(): void {
        this.fileUploadModalComponent.show();
    }

    downloadFile(id): void {
        this._fileDownloadService.downloadFile(id)
            .subscribe((response: Response) => {
                FileUtils.saveFile(FileUtils.getFilename(response), response.blob());
            });
    }

    downloadFiles(): void {
        let ids: string[] = [];
        const fileName = `${this.businessCustomerInformation.entityName}_legal_documents`;
        this.businessCustomerInformation.legalDocuments.map(item => ids.push(item.id));
        this._fileDownloadService.downloadAttachmentsFile(ids, fileName)
            .subscribe((response: Response) => {
                FileUtils.saveFile(FileUtils.getFilename(response), response.blob());
            });
    }

    removeFile(id): void {
        this.form.markAsTouched();
        this.businessCustomerInformation.legalDocuments =
            this.businessCustomerInformation.legalDocuments.filter((doc) => id !== doc.id);
    }

    onDateSelect(date: any) {
        this.form.markAsTouched();
        this.businessCustomerInformation.registrationDate = isNullOrUndefined(date.start) ? undefined : date.start.format(DATE_FORMAT);
        this.form.controls[this.CONTROL.REGISTRATION_DATE].setValue(this.businessCustomerInformation.registrationDate);
    }

    onDateChange(date: any) {
        if (!isNullOrUndefined(date)) {
            if (moment(date, 'DD.MM.YYYY').isSameOrBefore()) {
                this.daterangepickerOptions.settings.startDate = date;
            } else {
                this.businessCustomerInformation.registrationDate = moment().format('DD.MM.YYYY');
                this.daterangepickerOptions.settings.startDate = moment().format('DD.MM.YYYY');
                this.form.controls[this.CONTROL.REGISTRATION_DATE].setValue(this.businessCustomerInformation.registrationDate);
            }
        }
    }

    isSaveBtnDisabled() {
        return !this.form.valid
            || !(this.form.dirty || this.form.touched);
    }

    onEdit(): void {
        this.isEdited = true;
    }

    onDiscard(): void {
        this.businessCustomerInformation = cloneDeep(this.originalBusinessCustomerInformation);
        this.setBusinessTypeCategories(this.businessCustomerInformation.businessCategories
            .map(categoryId => this.sourceData.find(category => category.id == categoryId)));
        this.isEdited = false;
    }

    onSave(): void {
        if (this.originalBusinessCustomerInformation.userEmail !== this.businessCustomerInformation.userEmail) {
            this.showDialogBlock().subscribe(ok => {
                if (ok) {
                    this.updateBusinessCustomerInformation();
                }
            });
        } else {
            this.updateBusinessCustomerInformation();
        }

    }

    private updateBusinessCustomerInformation() {
        this.loadingState = true;
        this.businessCustomerInformation.businessCategories = this.getBusinessTypeCategories().map(c => c.id);
        if (!this.businessCustomerInformation.tradingName || this.businessCustomerInformation.tradingName.length == 0) {
            this.businessCustomerInformation.tradingName = null;
        }
        this._corporateAccountsService.updateBusinessCustomerInformation(this.profileId, this.businessCustomerInformation)
            .subscribe((businessCustomerInformation) => {
                this.businessCustomerInformation = cloneDeep(businessCustomerInformation);
                this.setBusinessTypeCategories(this.businessCustomerInformation.businessCategories
                    .map(categoryId => this.sourceData.find(category => category.id == categoryId)));
                this.loadingState = false;
            });
        this.isEdited = false;
    }

    isBusinessCategoriesInvalid(): boolean {
        let control = this.form.controls[this.CONTROL.BUSINESS_CATEGORY_FILTER];
        if (control.invalid && !control.value) {
            if (!isNullOrUndefined(control.errors[this.MIN_LIST_SIZE])) {
                return true;
            }
        }
        return false;
    }

    isRegistrationDateInvalid(): boolean {
        return this.form.controls[this.CONTROL.REGISTRATION_DATE].invalid;
    }

    getBusinessTypeCategories(): BusinessTypeCategory[] {
        let control = this.form.controls[this.CONTROL.BUSINESS_CATEGORIES];
        return (control) ? control.value : [];
    }

    setBusinessTypeCategories(value) {
        return this.form.controls[this.CONTROL.BUSINESS_CATEGORIES].setValue(value);
    }

    isInvalid(field: string): boolean {
        return this.form.controls[field].invalid;
    }

    isEmailValid(email: string) {
        return NewCorporateDetailsComponent.isEmailValid(this.form.controls[email].value);
    }

    hasError(field: string, error: string): boolean {
        return this.form.controls[field].hasError(error);
    }

    private showDialogBlock() {
        return new Observable(observer => {
            this.dialog
                .showConfirmDialog({
                    title: 'CUSTOMER.DETAILS.TAB.DETAILS.PRIVATE.APPLICANT_INFORMATION.DIALOG.TITLE',
                    message: 'CUSTOMER.DETAILS.TAB.DETAILS.PRIVATE.APPLICANT_INFORMATION.DIALOG.MESSAGE',
                    confirmButtonText: 'CUSTOMER.DETAILS.TAB.DETAILS.PRIVATE.APPLICANT_INFORMATION.DIALOG.OK',
                    cancelButtonText: 'CUSTOMER.DETAILS.TAB.DETAILS.PRIVATE.APPLICANT_INFORMATION.DIALOG.CANCEL'
                })
                .onConfirmAction(() => observer.next(true))
                .onCancelAction(() => observer.next(false))
        })
    }

    updateDocStatus(id: number, $event: Event) {
        const checkbox = event.target as HTMLInputElement;
        const isChecked = checkbox.checked;

        this._corporateAccountsService.updateLegalDocStatus(id, isChecked)
            .subscribe((usageReferral) => {
                this._notificationManager.success(
                    this._translationService.getValue('APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.COMMON.LEGAL_DOCUMENTS_VERIFY_UPDATED'),
                    5000
                );
            });
    }

    getDocStatus(idDb: number): void {

        this._corporateAccountsService.getLegalDocStatus(idDb)
            .subscribe((resp) => {
                return resp;
            });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/business.customer.information/business.customer.information.component.ts